module.exports = __webpack_public_path__ + "img/NoThumbnail.330da5ad.png";